import React from "react";
import PropTypes from "prop-types";

import { apolloClient } from "js/apollo/apollo-client";
import usePhotoDownload from "frontend/hooks/usePhotoDownload";

function DownloadPhotoLink({ downloadTier, photoId }) {
    const { startDownload } = usePhotoDownload({
        downloadTier,
        photoId,
        client: apolloClient
    });
    // Styled with sass because this link is only used by legacy screens
    return <button onClick={startDownload}>Download Photo</button>;
}

DownloadPhotoLink.propTypes = {
    downloadType: PropTypes.string.isRequired,
    photoId: PropTypes.string.isRequired
};

export default DownloadPhotoLink;
